<section class="container-fluid py-4">
  <div class="row justify-content-md-center mx-0">
    <div class="col-md-7 border-form p-md-5 p-4" *ngIf="formContent">
      <h1 class="mb-3" data-test-id="second-auth-lvl-title">
        {{
          (bindAuthenticator
            ? 'SECOND_AUTH_LVL_AUTHENTICATOR_HINT'
            : changePhone
              ? 'SECOND_AUTH_LVL_ADD_NEW_PHONE_HINT'
              : 'SECOND_AUTH_LVL_ENTER_CODE_HINT'
          ) | translate
        }}
      </h1>
      <div class="w-100" data-test-id="wrap-channel-kind-sms" *ngIf="!changePhone && !bindAuthenticator">
        <label class="form-label">
          {{ 'SECOND_AUTH_LVL_CHANNEL_KIND' | translate }}
        </label>
        <div class="row flex-column flex-md-row align-items-start" data-test-id="wrap-channel-kind-form">
          <div
            class="col-auto col-md-auto col-lg-4 col-xl-4 channel-kind-btn"
            *ngIf="availableChannels.includes('sms')"
            data-test-id="wrap-channel-kind-radio-sms-form"
          >
            <input
              type="radio"
              id="channelKindSms"
              data-test-id="channel-kind-radio-sms-input"
              class="channel-kind-radio"
              name="channelKind"
              [disabled]="isRequestCodeDisabled || isSmsChannelDisabled"
              [checked]="selectedChannel === 'sms'"
              (change)="onSelectedChannelType('sms')"
            />
            <label
              for="channelKindSms"
              data-test-id="sms-radio-btn-label"
              class="form-label channel-kind-label"
              [ngClass]="{ 'disabled-radio-label': isSmsChannelDisabled }"
              [ngbTooltip]="isSmsChannelDisabled ? ('TOOLTIP_CHANNEL_SHOULD_BE_CONFIGURED' | translate) : ''"
              >{{ 'SECOND_AUTH_LVL_PHONE_NUMBER_TITLE_HINT' | translate }}</label
            >
          </div>
          <button
            class="col-auto col-md-auto col-lg-3 col-xl-2 channel-kind-btn"
            data-test-id="wrap-channel-kind-radio-email-form"
            *ngIf="availableChannels.includes('email')"
          >
            <input
              type="radio"
              id="channelKindEmail"
              data-test-id="channel-kind-radio-email-input"
              class="channel-kind-radio"
              name="channelKind"
              [disabled]="isRequestCodeDisabled"
              [checked]="selectedChannel === 'email'"
              (change)="onSelectedChannelType('email')"
            />
            <label for="channelKindEmail" class="form-label channel-kind-label">{{
              'SECOND_AUTH_LVL_EMAIL_TITLE_HINT' | translate
            }}</label>
          </button>
          <button
            class="col-auto col-md-auto col-lg-4 col-xl-3 channel-kind-btn"
            data-test-id="wrap-channel-kind-radio-authenticator-form"
            *ngIf="availableChannels.includes('authenticator')"
          >
            <input
              type="radio"
              id="channelKindAuthenticator"
              data-test-id="channel-kind-radio-authenticator-input"
              class="channel-kind-radio"
              name="channelKind"
              [disabled]="isRequestCodeDisabled || (phoneNumber && isAuthenticatorChannelDisabled)"
              [checked]="selectedChannel === 'authenticator'"
              (change)="onSelectedChannelType('authenticator')"
            />
            <label
              for="channelKindAuthenticator"
              class="form-label channel-kind-label"
              data-test-id="authenticator-radio-btn-label"
              [ngClass]="{ 'disabled-radio-label': phoneNumber && isAuthenticatorChannelDisabled }"
              [ngbTooltip]="
                phoneNumber && isAuthenticatorChannelDisabled
                  ? ('TOOLTIP_CHANNEL_SHOULD_BE_CONFIGURED' | translate)
                  : ''
              "
              >{{ 'SECOND_AUTH_LVL_AUTHENTICATOR_TITLE_HINT' | translate }}
            </label>
          </button>
        </div>
      </div>
      <div *ngIf="selectedChannel != 'authenticator'" data-test-id="wrap-encrypted-phone-number">
        <div *ngIf="initialValue" class="constructor-form-group">
          <div class="pt-1 mb-n1" id="encrypted" data-test-id="encrypted-phone-number">
            {{ initialValue }}
          </div>
        </div>
        <div *ngIf="!initialValue || currentPhone" data-test-id="wrap-phone-number-form-field">
          <app-form-constructor
            (keydown.enter)="sendCode($event)"
            id="phone-number-form-field"
            data-test-id="phone-number-form-field"
            [formContent]="formContent"
          ></app-form-constructor>
        </div>
        <small
          *ngIf="(selectedChannel === 'sms' && !changePhone) || (changePhone && !currentPhone)"
          class="form-text text-muted my-1"
          data-test-id="second-auth-lvl-add-phone-hint"
        >
          {{ 'SECOND_AUTH_LVL_ADD_PHONE_HINT' | translate }}
        </small>
        <button
          *ngIf="selectedChannel === 'sms'"
          appLongOperation
          class="btn btn-primary d-block text-white send-code"
          type="button"
          data-test-id="second-auth-lvl-send-btn"
          (click)="sendCode($event)"
          [disabled]="(!phoneForm?.childForm?.form.valid && !phoneNumber) || isRequestCodeDisabled"
        >
          {{ requestCodeBtnHint }}
        </button>
        <button
          *ngIf="selectedChannel === 'email'"
          appLongOperation
          class="btn btn-primary d-block text-white send-code"
          type="button"
          data-test-id="second-auth-lvl-send-btn"
          (click)="sendCode($event)"
          [disabled]="isRequestCodeDisabled"
        >
          {{ requestCodeBtnHint }}
        </button>
      </div>
      <div
        *ngIf="selectedChannel == 'authenticator' && !bindAuthenticator"
        class="pt-3"
        data-test-id="wrap-generate-authenticator-form-field"
      >
        <button
          *ngIf="isRequestCodeDisabled"
          class="btn btn-primary d-block text-white send-code"
          type="button"
          data-test-id="second-auth-lvl-authenticator-timer-btn"
          [disabled]="isRequestCodeDisabled"
        >
          {{ authenticatorTimerHint }}
        </button>
        <span *ngIf="!isRequestCodeDisabled" class="text-muted col-12">{{
          'SECOND_AUTH_LVL_AUTHENTICATOR_CHANNEL_HINT' | translate
        }}</span>
        <div *ngIf="!isRequestCodeDisabled" class="col-12" data-test-id="wrap-generate-authenticator">
          <button
            *ngIf="authenticatorStatus != 'verified'"
            class="btn btn-primary mt-3"
            type="button"
            data-test-id="generate-authenticator-btn"
            (click)="generateAuthenticatorSecret()"
          >
            {{ 'BIND_AUTHENTICATOR_BTN' | translate }}
          </button>
        </div>
      </div>
      <div class="mt-2" data-test-id="attempts-limit-reached-test-id" *ngIf="verificationAttemptsLimitReached">
        <span class="text-muted">
          {{ 'SECOND_AUTH_LVL_VERIFICATION_ATTEMPTS_LIMIT_REACHED' | translate }}
        </span>
      </div>
      <div *ngIf="codeControl" class="constructor-form-group mt-1 pt-4" data-test-id="wrap-second-auth-lvl-code">
        <label class="form-label" for="code" data-test-id="second-auth-lvl-send-code-label">
          {{ 'SECOND_AUTH_LVL_CODE_FIELD_HINT' | translate }}
        </label>
        <input
          (keydown.enter)="verifyCode($event)"
          class="form-control"
          [ngClass]="{ 'is-invalid': isFieldInvalid() }"
          type="text"
          id="code"
          data-test-id="second-auth-lvl-code"
          placeholder="{{ 'SECOND_AUTH_LVL_PHONE_NUMBER_PLACE_HOLDER' | translate }}"
          [formControl]="codeControl"
          [maxlength]="6"
        />
        <small class="invalid-feedback" data-test-id="login-form-email-error">
          {{ getValidationError() | translate }}
        </small>
      </div>
      <div class="my-4" data-test-id="wrap-second-auth-lvl-verify-code-btn">
        <button
          appLongOperation
          class="btn btn-primary text-white me-3"
          type="button"
          [disabled]="!codeControl || codeControl.disabled || !codeControl.valid"
          data-test-id="second-auth-lvl-verify-code-btn"
          (click)="verifyCode($event)"
        >
          {{ 'SECOND_AUTH_LVL_CODE_VERIFY_HINT' | translate }}
        </button>
        <button class="btn btn-secondary" type="button" data-test-id="second-auth-lvl-cancel-btn" (click)="cancel()">
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
      <span
        id="second-auth-lvl-note"
        *ngIf="!changePhone && !bindAuthenticator"
        class="text-muted"
        data-test-id="second-auth-lvl-note"
      >
        {{ 'SECOND_AUTH_LVL_FORM_NOTE_HINT' | translate }}
      </span>
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="!formContent">
    <div class="spinner-grow text-primary load m-4" role="status">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </div>
</section>
